/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface AppointmentBookingFailure
 */
export interface AppointmentBookingFailure {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof AppointmentBookingFailure
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Error}
     * @memberof AppointmentBookingFailure
     */
    error: Error | null;
}

/**
 * Check if a given object implements the AppointmentBookingFailure interface.
 */
export function instanceOfAppointmentBookingFailure(value: object): value is AppointmentBookingFailure {
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function AppointmentBookingFailureFromJSON(json: any): AppointmentBookingFailure {
    return AppointmentBookingFailureFromJSONTyped(json, false);
}

export function AppointmentBookingFailureFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentBookingFailure {
    if (json == null) {
        return json;
    }
    return {
        
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'error': json['error'],
    };
}

export function AppointmentBookingFailureToJSON(json: any): AppointmentBookingFailure {
    return AppointmentBookingFailureToJSONTyped(json, false);
}

export function AppointmentBookingFailureToJSONTyped(value?: AppointmentBookingFailure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'error': value['error'],
    };
}

